import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { DisplayErrorService } from './services/display-error.service';
import { InternetCheckService } from './services/internet-check.service';
import { RouteTrackerService } from './services/route-tracker.service';
import { LocalService } from './services/storage/storage.service';
import { MemberDetails, UserDetails } from './components/models/dashboard.model';
import { IQuarterData, Quarter, QuarterData, Year } from './components/register/my-tasks/my-tasks.util';
import { FormControl } from '@angular/forms';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { getCurrentFinancialQuarter, getFinancialYearOptions } from './utils/util';
import { ICadreDetails, IUserProfile } from './interfaces/request-body.interface';
import { GEO_LOCATION, IGeoLocation } from './components/constants/geoLocation';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { UserService } from './services/user.service';
import { CRPAajeevika } from './components/constants/member.constants';
import { StateTenantIdMapping } from './components/constants/states';
import { CdnService } from './services/cdn.service';
import { CacheService } from './services/cache.service';

export interface UserInfo {
    id: string;
    name: string;
    userId: string;
    stateId: string;
    districtId: string;
    blockId: string;
    email: string;
    designation: string;
    mobile: string;
    blockName: string;
    // mappedPanchayatList: any[];
    // mappedVillageList: any[];
    roles: string;
}
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    protected title = 'aajeevika';
    protected showErrorPopup = false;
    protected errorData!: { hasImage: boolean; headerMessage?: string; imageName: string; message: string; type?: string };
    protected quarterSelectedControl: FormControl<Quarter> = new FormControl<Quarter>(QuarterData[0], { nonNullable: true });
    protected financialYearSelectedControl: FormControl<Year> = new FormControl<Year>({} as Year, { nonNullable: true });
    // private numberOfFinancialYearOption = 5;
    protected financialYearOptions: Year[] = [];
    private userInfo: UserInfo = {} as UserInfo;
    mappedPanchayatList: any;
    mappedVillageList: any;
    protected userDetails: UserDetails = {} as UserDetails;
    private stateTenantIdMapping = StateTenantIdMapping;
    geoLocation = [];


    constructor(
        private displayErrorService: DisplayErrorService,
        private internetCheckService: InternetCheckService,
        private routeTracker: RouteTrackerService,
        private translate: TranslateService,
        private localService: LocalService,
        private keycloakService: KeycloakService,
        private analytics: AngularFireAnalytics,
        private user: UserService,
        private cdn: CdnService,
        private cacheService: CacheService
    ) {
      const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    if (navEntries.length && navEntries[0].type === 'reload') {
      this.cacheService.setPageReload(true);
    }
        this.translate.setDefaultLang('en');
        this.translate.use('en');
    }

    async ngOnInit () {
        this.financialYearOptions = getFinancialYearOptions();
        this.setDefaultQuarterAndYear();
        if (environment.production) {
            this.routeTracker.trackRouteChanges();
        }
        this.displayErrorService.getData().subscribe({
            next: msg => {
                if (msg) {
                    this.errorData = {
                        hasImage: true,
                        headerMessage: msg?.header || 'cannotProcessRequestPleaseRetryAfterSometime',
                        imageName: msg.type === 'info' ? 'info-icon' :'somethingWentWrong',
                        message: msg.message
                    };
                    this.showErrorPopup = true;
                }
            }
        });

        this.internetCheckService.isOnline().subscribe({
            next: isConnected => {
                this.errorData = {
                    hasImage: true,
                    imageName: 'noInternet',
                    message: 'noInternetMessage'
                };
                this.showErrorPopup = !isConnected;
            }
        });
      this.getLocationAndUserDetails()
    }

    getUserInfo() {
          this.keycloakService.loadUserInfo().then((userInfo) => {
          this.syncAccount();
          const typedUserInfo = userInfo as IUserProfile;
            // console.log('User Info:', typedUserInfo);
            this.userInfo = {
                id: typedUserInfo.sub,
                name: typedUserInfo.name || '',
                userId: typedUserInfo.preferred_username,
                stateId: this.getGeoLocation(typedUserInfo, 'stateId', 'id'),
                districtId: this.getGeoLocation(typedUserInfo, 'districtId', 'id'),
                blockId: this.getGeoLocation(typedUserInfo, 'blockId', 'id'),
                email: typedUserInfo.email,
                designation: '',
                mobile: typedUserInfo.phone_number,
                roles: '',
                blockName: this.getGeoLocation(typedUserInfo, 'blockId', 'name'),
                // mappedPanchayatList: [],
                // mappedVillageList: [],
            };

            //setting user details
            // this.setUserDetails();

            this.user.getUserPermission(typedUserInfo.sub).subscribe((response: any) => {
                if(response && response.length){
                    const isUserAajeevika = response.includes('Livelihood Farm:CRP Aajeevika');
                    this.userInfo.roles = isUserAajeevika ? CRPAajeevika : '';
                    if(!isUserAajeevika) this.user.logout();
                       this.setUserDetails();
                        //update dashboard data
                        this.user.userDetails$.next(this.userDetails);

                    // this.user.getCadreDetails(typedUserInfo.sub).subscribe({
                    //     next: (response: ICadreDetails) => {
                    //         // this.userInfo.cadreDetails = response;
                    //         this.mappedPanchayatList = [{
                    //             id: response?.profile_response?.gram_panchayat_id,
                    //             name: response?.profile_response?.gram_panchayat
                    //         }];

                    //         this.mappedVillageList = [{
                    //             id: response?.profile_response?.village_id,
                    //             name: response?.profile_response?.village
                    //         }];

                    //         // this.getDashboardData();
                    //     },
                    //     error: (error) => {
                    //         console.error('Error fetching cadre details:', error);
                    //         this.displayErrorService.setData(error);
                    //         // this.user.logout();
                    //     }
                    // });

                    // this.getDashboardData();
                }
            }, error => {
                console.error('Error fetching user permissions:', error);
            });
        });
    }
    getLocationAndUserDetails(){
        this.cdn.getGeoLocation().subscribe((res: any) => {
            this.geoLocation = res;
            this.getUserInfo();
        });
    }
  syncAccount() {
    this.user.getLinkAccounts().subscribe({
      next: (res) => {
        console.log(
          ' SelectYourRoleComponent ~ this._user.getLinkAccounts ~ response:',
          res
        );
      },
      error: (err) => {
        console.log(
          ' SelectYourRoleComponent ~ this._user.getLinkAccounts ~ err:',
          err
        );
      },
    });
  }

    getGeoLocation(userInfo: IUserProfile, key: string, type: 'name' | 'id' = 'name') {
        const block = Object.keys(userInfo.resource_access).find(resource => resource.startsWith('B-'));
        const location:any = (this.geoLocation || GEO_LOCATION).find((location: IGeoLocation) => location.block_id === block);
        if (!location) return '';
        if(key === 'stateId') {
            if(type === 'id'){
                return location[`state_${type}`]?.split('-')[1] || '';
            }else if(type === 'name') {
                return location[`state_${type}`] || '';
            } else {
                return '';
            }
        } else if(key === 'districtId') {
            if(type === 'id'){
                return location[`district_${type}`]?.split('-')[1] || '';
            }else if(type === 'name') {
                return location[`district_${type}`] || '';
            } else {
                return '';
            }
        } else if(key === 'blockId') {
            if(type === 'id'){
                return location[`block_${type}`]?.split('-')[1] || '';
            }else if(type === 'name') {
                return location[`block_${type}`] || '';
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    setUserDetails () {
        console.log('setting user details');
        this.userDetails = {
            id: this.userInfo.id.toUpperCase(),
            name: this.userInfo.name || '',
            userId: this.userInfo.userId.toUpperCase(),
            stateId: this.userInfo.stateId,
            districtId: this.userInfo.districtId,
            blockId: this.userInfo.blockId,
            email: this.userInfo.email,
            designation: this.userInfo.designation,
            mobile: this.userInfo.mobile,
            roles: this.userInfo.roles || '',
            tenantId: '',
            // mappedPanchayatList: this.mappedPanchayatList,
            // mappedVillageList: this.mappedVillageList,
            blockName: this.userInfo.blockName || ''
        };
        console.log('User Details:-->', this.userDetails);
        // this.initials = this._helper.generateInitials(this.userDetails.name);
        // this._cdn.getBlockNameByBlockId(this.userDetails.stateId, this.userDetails.districtId, this.userDetails.blockId).subscribe(block => {
        //     this.userDetails.blockName = block ? block : '';
        // });
        this.localService.set('userDetails', this.userDetails);
        const tenant = this.stateTenantIdMapping.find((data: any) => {
            return +data.id == +this.userInfo.stateId;
        });
        this.localService.set('X-Tenant-Identifier', tenant?.tenentId || '');

        if (environment.production) {
            this.analytics.setUserId('LoKoS-Aajeevika');
            this.analytics.setUserProperties({ name: 'user', value: 'name' });
            this.analytics.logEvent('login', {
                username: this.userDetails?.userId
            });
        }

    }

    private setDefaultQuarterAndYear () {
        const memberDetails = this.localService.get<MemberDetails>('memberDetails');
        if (memberDetails && memberDetails.quarter && memberDetails.year) {
            const { quarter, quarterLabel, year, yearLabel } = memberDetails;
            this.quarterSelectedControl.setValue({ quarter, quarterLabel });
            this.financialYearSelectedControl.setValue({ year, yearLabel });
        } else {
            const currentFinancialQuarter = getCurrentFinancialQuarter();
            if(currentFinancialQuarter == 1){
                const quarterData = QuarterData.find((data: IQuarterData) => data.quarter === 4) || {} as IQuarterData;
                this.quarterSelectedControl.setValue(quarterData);
            } else {
                const quarterData = QuarterData.find((data: IQuarterData) => data.quarter === currentFinancialQuarter - 1) || {} as IQuarterData;
                this.quarterSelectedControl.setValue(quarterData);
            }
            this.financialYearSelectedControl.setValue({ ...this.financialYearOptions[0] });

            const details: MemberDetails = {
                id: '',
                memberId: 0,
                name: '',
                shgCode: '',
                quarter: this.quarterSelectedControl?.value.quarter,
                quarterLabel: this.quarterSelectedControl?.value.quarterLabel,
                year: +this.financialYearSelectedControl?.value.year,
                yearLabel: this.financialYearSelectedControl?.value.yearLabel,
                memberName: '',
                memberCode: '',
                livelihoodCategories: ''
            };
            this.localService.set('memberDetails', details);
        }
    }
}
